// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"MainCarousel_carouselWrapper__1kKee","bannerLink":"MainCarousel_bannerLink__2eK1K"};